var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditlineincreases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 33,
    r: 23,
    fill: "#B5D7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.555 23.9538V46.6263H43.0185V23.9538H47.5756L36.1831 9.55811L25.1016 23.9538H29.555Z",
    fill: "#166BCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.995 50.592H29.6001V54.5352H42.995V50.592Z",
    fill: "#166BCD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.995 55.5837H29.6001V57.688H42.995V55.5837Z",
    fill: "#328CE1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.995 58.7363H29.6001V59.6251H42.995V58.7363Z",
    fill: "#7EB3F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 30.825C18 29.7377 18.8814 28.8562 19.9688 28.8562H54.389C55.4763 28.8562 56.3578 29.7377 56.3578 30.825V49.8511C56.3578 50.9384 55.4763 51.8199 54.389 51.8199H19.9688C18.8814 51.8199 18 50.9384 18 49.8511V30.825Z",
    fill: "#166BCD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2266 29.8125C17.2266 28.8805 17.9821 28.125 18.9141 28.125H53.8968C54.8289 28.125 55.5843 28.8805 55.5843 29.8125V49.4011C55.5843 50.3332 54.8289 51.0886 53.8968 51.0886H18.9141C17.9821 51.0886 17.2266 50.3332 17.2266 49.4011V29.8125Z",
    fill: "#7EB3F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.165 42.5248H45.1787C44.5574 42.5248 44.0537 43.0285 44.0537 43.6498V46.8122C44.0537 47.4336 44.5574 47.9372 45.1787 47.9372H51.165C51.7864 47.9372 52.29 47.4336 52.29 46.8122V43.6498C52.29 43.0285 51.7864 42.5248 51.165 42.5248Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6641 36H21.1641C20.8534 36 20.6016 36.2518 20.6016 36.5625V38.8125C20.6016 39.1232 20.8534 39.375 21.1641 39.375H25.6641C25.9747 39.375 26.2266 39.1232 26.2266 38.8125V36.5625C26.2266 36.2518 25.9747 36 25.6641 36Z",
    fill: "#328CE1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.415 44.2704H21.8644C21.3824 44.2704 20.9917 44.6612 20.9917 45.1432V45.5795C20.9917 46.0615 21.3824 46.4523 21.8644 46.4523H35.415C35.897 46.4523 36.2878 46.0615 36.2878 45.5795V45.1432C36.2878 44.6612 35.897 44.2704 35.415 44.2704Z",
    fill: "#CEE6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditlineincreases);
export default __webpack_public_path__ + "static/media/creditlineincreases.a9a6ad10c35a4be2a6260170f5ad8578.svg";
export { ForwardRef as ReactComponent };